import React, { useState } from 'react';
import {
  Row,
  Col,
  Card,
  Button,
  Tooltip,
  Skeleton,
} from 'antd';
import { EnvironmentTwoTone } from '@ant-design/icons';
import moment from 'moment';
import { useSelector, useDispatch } from 'react-redux';
import { CustomAlertModal } from '../../../shared';
//import { SetAppliedJobs, UpdateUser } from '../../../actions';
import { GlobalApiErrorHandler } from '../../../shared/helpers'
import { MsgBox } from '../../../shared/custom-ant-d'
import { isMobile } from 'react-device-detect';
import { AppStatus } from '../../../constants/AppStatus';
import { reqPostSaveApplication } from '../../../axios/api'

export const JobsApplied = (props) => {
  const JobList = useSelector(state => state.AppliedJobs);
  const Auth = useSelector(state => state.Auth);
  const dispatch = useDispatch();

  const [isWithdrawModalVisible, setIsWithdrawModalVisible] = useState(false);
  const [applicationId, setApplicationId] = useState(null);

  const withdrawApplication = (e) => {
    e.preventDefault();
    setIsWithdrawModalVisible(false);

    var application = JobList.filter((item, i) => {
      return item.applicationID === applicationId;
    });

    if (application.length > 0) {
      var formData = application[0];
      formData.Action = 'WITHDRAW';
      formData.action = 'WITHDRAW';
      formData.ApplicationID = formData.applicationID;
      formData.CandidateID = parseInt(formData.candidateID);
      formData.JobReqID = parseInt(formData.jobReqID);
      formData.JobPostingID = parseInt(formData.jobPostingID);
      formData.legalFirstName = Auth.firstName;
      formData.legalLastName = Auth.lastName;
      formData.personalEmail = Auth.personalEmail;
      formData.homeCountryID = Auth.countryID;
      formData.Is18OrOlder = false;
      formData.WorkedAtiQorInd = false;
      formData.IsSponsorshipRequired = false;
      formData.AvailableWeekendInd = false;
      formData.AvailableEveningInd = false;
      formData.ScheduleRestrictionsInd = false;

      var formStr = JSON.stringify(formData);
      props.setIsJobApplicationLoading(true);

      reqPostSaveApplication(formStr)
        .then(res => {
          MsgBox({
            type: 'success',
            message: '',
            description: 'Your application has been withdrawn.',
          });
          props.getProfileDetails(true);
        })
        .catch(err => {
          GlobalApiErrorHandler({ errors: err.response.data.errors });
          console.log(err);
        });
    }
  }

  const openWithdrawModal = (e, applicationId) => {
    e.preventDefault();
    setIsWithdrawModalVisible(true);

    setApplicationId(applicationId);
  }

  const Content = () => {
    return (
      <>

        <Row justify="left">
          <Col md={24} xs={24}>
            {
              props.isJobApplicationLoading ? (
                <>
                  <Skeleton active />
                </>
              ) : (
                !isMobile ? (
                  <>
                    <Row>
                      {
                        JobList && JobList.map((item, i) => {
                          return (
                            <div className="ant-col ant-col-xs-24 ant-col-md-7 jobs-applied-col" key={i}>
                              <Tooltip placement="topLeft" title={item.postingJobTitle + " - #" + item.jobReqID} arrowPointAtCenter>
                                <Card title={item.postingJobTitle + " - #" + item.jobReqID} className="jobs-applied">
                                  <ul className="hide-list-style">
                                    <li><EnvironmentTwoTone className="inline-icon" twoToneColor="#52c41a" /> {item.postingCity + ", " + (item.postingState ? (item.postingState + ", ") : "") + item.postingCountryCode}</li>
                                    {
                                      (item.appStatus == AppStatus.Withdrawn) ?
                                        (<li style={{ color: 'red' }}>{item.appStatus}</li>) :
                                        (<li>{item.appStatus}</li>)
                                    }
                                    <li>{moment(item.createdDt).format('MM/DD/YYYY')}</li>
                                  </ul>

                                  {(![AppStatus.Withdrawn, AppStatus.Hired, AppStatus.Closed].includes(item.appStatus)) ? (
                                    <Button style={{ right: 'unset', left: '20%', bottom: 'unset' }} className="center-btn" type="danger" htmlType="button" onClick={e => openWithdrawModal(e, item.applicationID)}>
                                      Withdraw Application
                                    </Button>
                                  ) : ("")}
                                </Card>
                              </Tooltip>
                            </div>
                          )

                        })
                      }
                    </Row>
                  </>
                ) : (
                  <>
                    <Row>
                      {
                        JobList && JobList.map((item, i) => {
                          return (
                            <div className="ant-col ant-col-xs-24 ant-col-md-24 jobs-applied-col" key={i}>
                              <Tooltip placement="topLeft" title={item.postingJobTitle + " - #" + item.jobReqID} arrowPointAtCenter>
                                <Card title={item.postingJobTitle + " - #" + item.jobReqID} className="jobs-applied">
                                  <ul className="hide-list-style">
                                    <li><EnvironmentTwoTone className="inline-icon" twoToneColor="#52c41a" /> {item.postingCity + ", " + (item.postingState ? (item.postingState + ", ") : "") + item.postingCountryCode}</li>
                                    {
                                      (item.appStatus == AppStatus.Withdrawn) ?
                                        (<li style={{ color: 'red' }}>{item.appStatus}</li>) :
                                        (<li>{item.appStatus}</li>)
                                    }
                                    <li>{moment(item.createdDt).format('MM/DD/YYYY')}</li>
                                  </ul>

                                  {(![AppStatus.Withdrawn, AppStatus.Hired].includes(item.appStatus)) ? (
                                    <Button className="center-btn" type="danger" htmlType="button" onClick={e => openWithdrawModal(e, item.applicationID)}>
                                      Withdraw Application
                                    </Button>
                                  ) : ("")}
                                </Card>
                              </Tooltip>
                            </div>
                          )

                        })
                      }
                    </Row>

                  </>
                )
              )

            }
          </Col>
        </Row>
      </>
    )
  }

  return (
    <>
      <Row justify="center">
        <Col sm={23} xs={24}>
          <Card title="Jobs Applied" className="iqor-header">
            {
              (props.isProfileLoading || props.isJobApplicationLoading) ? (<Skeleton active />) : (<Content />)
            }
          </Card>
        </Col>
      </Row>

      <CustomAlertModal
        type="confirm"
        content="Are you sure you want to withdraw your application?"
        onCancel={() => { setIsWithdrawModalVisible(false) }}
        visible={isWithdrawModalVisible}
        destroyOnClose={true}
        footer={[
          <Button
            key='yes'
            onClick={e => withdrawApplication(e)}
            type="danger"
          >
            Yes
          </Button>,
          <Button
            key='no'
            onClick={e => setIsWithdrawModalVisible(false)}
            type="danger"
          >
            No
          </Button>
        ]}
      />
    </>
  )
}
